export const OMNICHANNEL_CONNECT_BROADCAST = 'sellyt-omnichannel-connect';

export type OmnichannelConnectBroadcast =
  | { type: 'success'; channel: string }
  | { type: 'error'; channel?: string };

export function broadcastOmnichannelConnectResult(
  payload: OmnichannelConnectBroadcast
) {
  try {
    const channel = new BroadcastChannel(OMNICHANNEL_CONNECT_BROADCAST);
    channel.postMessage(payload);
    channel.close();
  } catch {
    window.opener?.postMessage(
      { source: OMNICHANNEL_CONNECT_BROADCAST, ...payload },
      window.location.origin
    );
  }
}

export function subscribeOmnichannelConnectResult(
  handler: (payload: OmnichannelConnectBroadcast) => void
) {
  let broadcastChannel: BroadcastChannel | null = null;

  try {
    broadcastChannel = new BroadcastChannel(OMNICHANNEL_CONNECT_BROADCAST);
    broadcastChannel.onmessage = (
      event: MessageEvent<OmnichannelConnectBroadcast>
    ) => {
      handler(event.data);
    };
  } catch {
    // BroadcastChannel unavailable — window message fallback below.
  }

  const onWindowMessage = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;
    const data = event.data as OmnichannelConnectBroadcast & {
      source?: string;
    };
    if (data?.source !== OMNICHANNEL_CONNECT_BROADCAST) return;
    handler(data);
  };

  window.addEventListener('message', onWindowMessage);

  return () => {
    broadcastChannel?.close();
    window.removeEventListener('message', onWindowMessage);
  };
}

/**
 * Opens a blank tab synchronously on user click (required for popup policy).
 * The OAuth URL is assigned later via `assignOmnichannelConnectUrl`.
 */
export function openOmnichannelConnectBlankTab(): Window | null {
  try {
    return window.open('about:blank', '_blank');
  } catch {
    return null;
  }
}

/** Navigates a pre-opened connect tab to the OAuth URL. */
export function assignOmnichannelConnectUrl(popup: Window, url: string): void {
  popup.location.href = url;
}

export function closeOmnichannelConnectTab(
  popup: Window | null | undefined
): void {
  try {
    popup?.close();
  } catch {
    // ignore
  }
}
